if (!customElements.get('armrest-upsell')) {
  customElements.define('armrest-upsell', class extends HTMLElement {
    constructor() {
      super();
      this.selected = false;
      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
    }

    connectedCallback() {
      this.product = this.closest('product-info');
      this.toggle = this.querySelector('[data-armrest-toggle]');
      if (this.toggle) this.toggle.disabled = false;
      this.addEventListener('click', this.onClick);
      this.product.addEventListener('change', this.onChange);
      this.product.addEventListener('submit', this.onSubmit, true);
      this.unsubscribeQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.syncPrices());
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.product.removeEventListener('change', this.onChange);
      this.product.removeEventListener('submit', this.onSubmit, true);
      this.unsubscribeQuantity();
    }

    get quantityInput() {
      return document.forms[this.dataset.formId]?.elements.namedItem('quantity');
    }

    get formIds() {
      return [this.dataset.formId, `sticky-${this.dataset.formId}`];
    }

    onClick(event) {
      if (event.target.closest('a, input, label, fieldset') || !this.toggle) return;
      this.selected = !this.selected;
      this.classList.toggle('armrest-upsell--selected', this.selected);
      this.toggle.setAttribute('aria-pressed', String(this.selected));
      this.toggle.textContent = this.selected ? this.toggle.dataset.labelAdded : this.toggle.dataset.labelAdd;
      this.syncPrices();
    }

    onChange(event) {
      if (event.target.matches('[data-armrest-choice]') && this.contains(event.target)) {
        event.stopPropagation();
        const template = this.querySelector(`template[data-armrest-variant="${event.target.value}"]`);
        this.querySelector('[data-armrest-content]').replaceWith(template.content.cloneNode(true));
        this.syncPrices();
      } else if (event.target === this.quantityInput) {
        this.syncPrices();
      }
    }

    syncPrices() {
      const addon = this.selected ? Number(this.querySelector('[data-armrest-content]').dataset.price) : 0;
      const quantity = Number(this.quantityInput?.value || 1);
      const prices = this.formIds.flatMap((id) => Array.from(document.getElementById(id)?.querySelectorAll('.price') || []));
      prices.forEach((price) => {
        price.querySelectorAll('.price-item').forEach((amount) => {
          const base = amount.closest('.price__sale') && amount.classList.contains('price-item--regular')
            ? this.dataset.compareAtPrice : this.dataset.unitPrice;
          const total = (Number(base) * quantity + addon) / 100;
          amount.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency: this.dataset.currency,
            minimumFractionDigits: Number.isInteger(total) ? 0 : 2,
          }).format(total);
        });
      });
    }

    onSubmit(event) {
      const form = event.target;
      if (!this.formIds.includes(form.getAttribute('id'))) return;
      const productForm = form.closest('product-form');
      if (!productForm?.onSubmitHandler) return;
      productForm.prepareConfiguredCart = async (formData) => {
        const quantity = this.quantityInput;
        if (quantity && (!quantity.checkValidity() || Number(quantity.value) < 1)) {
          throw new Error(quantity.validationMessage || window.variantStrings.quantityError.replace('[quantity]', quantity.min || '1'));
        }
        formData.set('quantity', quantity?.value || '1');
        if (!this.selected) return [];
        const option = this.querySelector('[data-armrest-choice]:checked:enabled');
        const properties = Object.fromEntries(Array.from(
          this.querySelectorAll('[data-armrest-content] [name^="properties["]'),
          (input) => [input.name.slice(11, -1), input.value]
        ));
        return [{ id: Number(option.value), quantity: 1, properties }];
      };
      event.stopImmediatePropagation();
      productForm.onSubmitHandler(event);
    }
  });
}
